import { MdArrowForwardIos } from "react-icons/md";
import icon from "../../../assests/solutionImages/MultiUrl/IconTheme.svg";
import bgimgMultiurl from "../../../assests/solutionImages/MultiUrl/Bgthemeimg.svg";

// Helper to get image URL (fallback to default if needed)
function getImageUrl(profileImage, fallback) {
  return profileImage || fallback;
}

// Helper to get section icon
function getSectionIcon(section) {
  return section?.iconImage ? section.iconImage : icon;
}

function MultiUrlInterFaceTheme({ card }) {
  console.log(card);

  // Destructure card data for clarity
  const {
    profileImage,
    name,
    data = {},
  } = card || {};
  const {
    isProfileVisible,
    heading,
    subHeading,
    formTitle,
    formDescription,
    sections = [],
  } = data;

  return (
    <div className="flex p-2 md:py-4 justify-center min-h-screen bg-gray-200 ">
      <div className="relative w-full max-w-[393px] overflow-y-auto scrollbar-hide bg-white rounded-xl">
        {/* Cover Image */}
        <div className="relative">
          <img
            src={card?.backgroundImage || bgimgMultiurl}
            alt="Cover"
            className="w-full h-48 object-cover"
          />

          {/* Profile Image (overlapping bottom of cover) */}
          {(card?.profileImage && card?.data?.isProfileVisible) && (
            <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2 rounded-full overflow-hidden w-36 h-36 bg-white">
              <img
                src={card.profileImage}
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>
          )}
        </div>

        <div
          className={`text-center ${
            card?.profileImage && card?.data?.isProfileVisible ? 'pt-20' : 'pt-6'
          } px-4 max-w-[306px] mx-auto`}
        >
          <h2 className="text-3xl font-bold break-words">{name}</h2>
          <p className="text-gray-600 break-words">{heading}</p>
          {subHeading && (
            <p className="text-gray-800 font-semibold break-words">{subHeading}</p>
          )}
        </div>

        <div>
          <div className="grid grid-cols-1 gap-2 items-center justify-between p-4 text-white w-full h-full">
            <div className="py-4">
              <div className="flex flex-col justify-center items-center bg-custom-dark rounded-t-xl p-4">
                <p className="text-xl font-bold break-all text-center text-custom-gradient">{formTitle || 'Title'}</p>

                <p className="text-base text-center break-all">{formDescription || 'Description'}</p>
              </div>

              {sections.map((section, index) => (
                <div
                  key={section.key || index}
                  className={`
                    flex justify-center bg-custom-dark items-center gap-1 p-4 w-full h-full
                    ${index === 0 ? 'rounded-b-xl' : 'rounded-xl'}
                    ${index !== sections.length - 1 ? 'mb-4' : ''}
                  `}
                  onClick={() => section.url && window.open(section.url, '_blank')}
                  style={{ cursor: section.url ? 'pointer' : 'default' }}
                >
                  <div className="flex-shrink-0 w-10 h-10">
                    <img
                      src={getSectionIcon(section)}
                      alt="Section Icon"
                      className="w-10 h-10 object-contain"
                    />
                  </div>
                  <div className="w-full h-full ml-2">
                    <p className="text-lg font-bold max-w-[200px] break-words text-custom-gradient">
                      {section.pdfTitle || 'Title'}
                    </p>
                    <p className="text-sm max-w-[200px] break-words">
                      {section.pdfSubtitleEnabled ? section.pdfSubtitle : 'Visit for more information'}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <MdArrowForwardIos />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiUrlInterFaceTheme;

